import {AxiosError} from 'axios';
import {DefaultOtpType} from '../../api/user/model';
import {PUT_USER_SETTINGS_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface PutUserSettingsRequest {
  otpType: DefaultOtpType;
}

interface PutUserSettingsResponse {
  otpType: DefaultOtpType;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PutUserSettingsResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutUserSettings = ({onSuccess, onError}: Input = {}) => {
  const putUserSettings = async (reqBody: PutUserSettingsRequest) => {
    const res = await axiosClient.put<PutUserSettingsResponse>(PUT_USER_SETTINGS_URL, reqBody);

    return res.data;
  };

  return useCustomMutation(putUserSettings, {
    onSuccess,
    onError,
  });
};
